import React, { useState} from "react";
import { useHistory, Link } from "react-router-dom";
import MultilevelSidebar from "react-multilevel-sidebar";
import "react-multilevel-sidebar/src/Sidebar.css";
import { AiOutlineMenu, AiOutlineHome, AiTwotoneSecurityScan } from "react-icons/ai";
import { hasReadPermission } from "../../../service/userService";

let CMSOptions = [
    {
        content: [
            {
                id: 1,
                name: "Home",
                href: '/Opportunity',
                icon: <AiOutlineHome />,
                securityObject: hasReadPermission('Top.LookupRequest')
            }
        ]
    }, {
        content: [
            {
                id: 2,
                name: "Opportunity",
                href: '/',
                icon: <AiOutlineHome />,
                securityObject: hasReadPermission('Top.Locations')
            }
        ]
    },  {
        content: [
            {
                id: 4,
                name: "Admin",
                icon: <AiOutlineHome />,  
                securityObject: hasReadPermission('Top.Locations'),
                children: [
                    {
                        content: [
                            {
                                id: 3,
                                name: "Office Location",
                                href: '/Office-Location',
                                icon: <AiOutlineHome />,
                                securityObject: hasReadPermission('Top.Locations')
                            }
                        ]
                    }, {
                        content: [
                            {
                                id: 2,
                                name: "Add Lookup",
                                href: '/Add-Lookup',
                                icon: <AiOutlineHome />,
                                securityObject: hasReadPermission('Top.LookupRequest')
                            }
                        ]
                    }, //{
                    //    content: [
                    //        {
                    //            id: 2,
                    //            name: "Lookup Request",
                    //            href: '/Lookup-Request',
                    //            icon: <AiOutlineHome />
                    //        }
                    //    ]
                    //}, 
                    {
                        content: [
                            {
                                id: 2,
                                name: "Project Score Card Version",
                                href: '/Project-Score-Card',
                                icon: <AiOutlineHome />
                            }
                        ]
                    }, {
                        content: [
                            {
                                id: 4,
                                name: "Chart color",
                                href: '/Chart-color',
                                icon: <AiOutlineHome />
                            }
                        ]
                    }, {
                        content: [
                            {
                                id: 4,
                                name: "Opportunity Chart",
                                href: '/opportunitychart',
                                icon: <AiOutlineHome />
                            }
                        ]
                    }
                ]
            },
            {
                content: [
                    {
                        id: 1,
                        name: "Security",
                        href: setting.securityWebUrl + "app/security?source=" + btoa("advantage"),
                        EventTarget: '_blank',
                        icon: <AiTwotoneSecurityScan />,
                        securityObject: hasReadPermission('Security'),
                    }
                ]
            }
        ]
    }    
].filter((item) => { return item.content[0].securityObject == true; });

const Sidebar = () => {

    /*const { getSettingValue } = useContext(WebSiteContext)*/

    const history = useHistory();
    const [openCMS, setIsopenCMS] = useState(false);

    const handleSidebarCMSToggle = (isOpen) => {
        setIsopenCMS(isOpen);
    };

    const handleClick = (itemOptions) => {
        if (itemOptions.href) {
            history.push(itemOptions.href);
            setIsopenCMS(false);
        }
    }

    const logoSidebarMenu = () => {
        return (
            <div className="logoDashboardSidebarWrapper">
                <Link to="/">
                    {/*<img src={"data:image/png;base64, " + getSettingValue('website logo')} className="logoDashboardSidebar" />*/}
                </Link>
            </div>
        )
    }

    return (<>
        <div className="sidebarPanel">
            <div className="logoWrapper">
                <Link to="/">
                    {/*<img src={"data:image/png;base64, " + getSettingValue('website logo')} className="logoDashboard" />*/}
                </Link>
            </div>
            <div className="menuWrapper">
                <MultilevelSidebar
                    open={openCMS}
                    onToggle={() => handleSidebarCMSToggle()}
                    options={CMSOptions}
                    header={logoSidebarMenu()}
                    onItemClick={handleClick}
                />
                <div onClick={() => handleSidebarCMSToggle(true)} className="MenuOpenIcon" title="Sidebar Menu">
                    <AiOutlineMenu size="20" color="#fff" />
                </div>
            </div>
        </div>
    </>)
}

export default Sidebar;